import { type MergedCoupon } from '@cart-services/types'
import { Button } from '@pets-ui/Button/Button'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { HStack } from '@pets-ui/HStack/HStack'
import { ResponsiveDialog } from '@pets-ui/ResponsiveDialog/ResponsiveDialog'
import { Text } from '@pets-ui/Text/Text'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'
import { HEADER_HEIGHT } from '../../constants'
import { CouponFilterItem } from './CouponFilterItem'

interface DialogCouponOverviewProps {
  open: boolean
  onClose: () => void
  tabCoupons: MergedCoupon[]
  selectedCouponIds: Set<number>
  toggleCoupon: (couponId: number) => void
  selectAllTabCoupons: () => void
  deselectAllCoupons: () => void
}

export const DialogCouponOverview = ({
  open,
  onClose,
  tabCoupons,
  selectedCouponIds,
  toggleCoupon,
  selectAllTabCoupons,
  deselectAllCoupons,
}: DialogCouponOverviewProps) => {
  const isMobile = useResponsive('mobile')
  const hasSelection = selectedCouponIds.size > 0
  const handleToggleAll = hasSelection ? deselectAllCoupons : selectAllTabCoupons

  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxHeight={isMobile ? `calc(100dvh - ${HEADER_HEIGHT}px)` : '80vh'}
    >
      <DialogHeader title="品牌優惠" onClose={onClose} />
      <HStack alignItems="center" px={4} pb={2} gap={2}>
        <Text color="grey">看看哪些商品能用券？</Text>
        <Button
          variant="text"
          size="small"
          color="blue"
          onClick={handleToggleAll}
        >
          {hasSelection ? '取消選取' : '選取全部'}
        </Button>
      </HStack>
      <DialogContent>
        <VStack gap={4}>
          {tabCoupons.map(coupon => (
            <HStack key={coupon.coupon_id} minHeight={92}>
              <CouponFilterItem
                coupon={coupon}
                isSelected={selectedCouponIds.has(coupon.coupon_id)}
                onToggle={toggleCoupon}
              />
            </HStack>
          ))}
        </VStack>
      </DialogContent>
      <DialogActions>
        <Button fullWidth onClick={onClose}>確定</Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
